import { AbstractControl, ValidatorFn, Validators } from '@angular/forms';

export class NotEqualWith extends Validators {
  static validate(compareControl: AbstractControl): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      let result: any = { valuesMatch: { value: control.value }};
      let valid = false;

      try {
        if (compareControl instanceof Array) {
          compareControl.forEach((controlForCompare: AbstractControl) =>
            valid = valid && NotEqualWith.compareValues(control, controlForCompare));
        } else if (compareControl instanceof AbstractControl) {
          valid = NotEqualWith.compareValues(control, compareControl);
        }

        if (valid) {
          result = null;
        }

      } catch (err) {
      }

      return result;
    };
  }

  private static compareValues(control: AbstractControl, controlForCompare: AbstractControl): boolean {
    return control.value !== controlForCompare.value;
  }
}
